module.exports = __webpack_public_path__ + "img/oats_nso21003.806c4da6.jpg";